
        <div class="modal-dialog" [class.modal-sm]="isSmall" [class.modal-lg]="isLarge">
            <div class="modal-content">
                <ng-content></ng-content>
            </div>
        </div>
    